import { Injectable } from '@angular/core';
import { RoleEnum } from '../api-module/user-management-api-client-v2';

@Injectable({
    providedIn: 'root'
})
export class RoleMappingService {
    constructor() {}

    public static getRoleEnum(name: string): RoleEnum {
        switch (name) {
            case 'General Access':
                return RoleEnum.GeneralAccess;
            case 'Clinical Feedback':
                return RoleEnum.ClinicalFeedback;
            case 'Imaging Request Viewer':
                return RoleEnum.ImagingRequestViewer;
            case 'Imaging Request Editor':
                return RoleEnum.ImagingRequestEditor;
            case 'Admin':
                return RoleEnum.Admin;
            case 'Demand Management':
                return RoleEnum.DemandManagement;
            default:
                console.error('Unexpected role: ' + name);
                return RoleEnum.Unknown;
        }
    }

    public static getRoleDisplayName(role: RoleEnum | string): string {
        switch (role) {
            case RoleEnum.Admin:
                return 'Admin (User Management Only)';
            case RoleEnum.GeneralAccess:
                return 'General Access (e.g. Create Orders)';
            case RoleEnum.ClinicalFeedback:
                return 'Clinical Feedback';
            case RoleEnum.ImagingRequestViewer:
                return 'Imaging Request Viewer';
            case RoleEnum.ImagingRequestEditor:
                return 'Imaging Request Editor';
            case RoleEnum.DemandManagement:
                return 'Demand Management';
            default:
                return role as string;
        }
    }
}
